import { render } from "./EgmUpload.vue?vue&type=template&id=988baac6&scoped=true"
import script from "./EgmUpload.vue?vue&type=script&lang=js"
export * from "./EgmUpload.vue?vue&type=script&lang=js"

import "./EgmUpload.vue?vue&type=style&index=0&id=988baac6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-988baac6"]])

export default __exports__